import { CharacterData } from "../../../../utils/game/character/CharacterData";
import { Point2d } from "../../../../common/geometry/Geom2d";

import ImageLoader from "../../../../common/utilities/ImageLoader";
import TabletopDimensionalElement from "../element/TabletopDimensionalElement";
import TabletopViewport from "../TabletopViewport";

export default class TabletopToken extends TabletopDimensionalElement {
    private _imgSrc: string | null = null;
    private _img: ImageBitmap | null = null;
    private _highlighted: boolean = false;
    private _selected: boolean = false;
    private _showLabel: boolean = true;

    public constructor(args?: {
        x?: number | (() => number);
        y?: number | (() => number);
        width?: number | (() => number);
        height?: number;
        imgSrc?: string;
        characterData?: CharacterData;
    }) {
        super({
            x: args?.x,
            y: args?.y,
            width: args?.width,
            height: args?.height,
        });

        if (args?.imgSrc != null) {
            this.imgSrc = args.imgSrc;
        }
    }

    public override get left(): number {
        return this.x - this.width / 2;
    }

    public override get right(): number {
        return this.x + this.width / 2;
    }

    public override get top(): number {
        return this.y - this.height / 2;
    }

    public override get bottom(): number {
        return this.y + this.height / 2;
    }

    public get imgSrc() {
        return this._imgSrc;
    }
    public set imgSrc(val: string | null) {
        if (val == null) {
            this._imgSrc = null;
            this._img = null;
            return;
        }

        this._imgSrc = val;
        ImageLoader.loadImage(val, (image) => {
            this._img = image;
        });
    }

    public get highlighted(): boolean {
        return this._highlighted;
    }
    public set highlighted(val: boolean) {
        this._highlighted = val;
    }

    public get selected(): boolean {
        return this._selected;
    }
    public set selected(val: boolean) {
        this._selected = val;
    }

    public get showLabel(): boolean {
        return this._showLabel;
    }
    public set showLabel(val: boolean) {
        this._showLabel = val;
    }

    public override containsPoint(point: Point2d): boolean {
        return (
            Math.pow(point.x - this.x, 2) / Math.pow(this.width / 2, 2) +
                Math.pow(point.y - this.y, 2) / Math.pow(this.height / 2, 2) <=
            1
        );
    }

    public override draw(
        ctx: CanvasRenderingContext2D,
        viewport: TabletopViewport,
        timestamp: number,
    ) {
        if (this._img != null) {
            const positionInViewport = viewport.universePointToViewportPoint(
                this.topLeft,
            );
            ctx.drawImage(
                this._img,
                positionInViewport.x,
                positionInViewport.y,
                this.width * viewport.magnificationX,
                this.height * viewport.magnificationY,
            );
        }

        if (this.highlighted || this.selected) {
            const origin = viewport.universePointToViewportPoint({
                x: this.x,
                y: this.y,
            });

            if (this.selected) {
                const rotation = 2 * Math.PI * ((timestamp % 2000) / 2000);
                ctx.strokeStyle = "black";
                ctx.lineWidth = 3;
                ctx.beginPath();

                for (let rad = 0; rad < Math.PI * 2; rad += (Math.PI * 2) / 6) {
                    const x = Math.cos(rad + rotation);
                    const y = Math.sin(rad + rotation);

                    ctx.lineTo(
                        origin.x + x * this.width * viewport.magnificationX,
                        y +
                            origin.y +
                            y * this.height * viewport.magnificationY,
                    );
                }

                ctx.stroke();
            }

            if (this.highlighted) {
                ctx.beginPath();
                ctx.ellipse(
                    origin.x,
                    origin.y,
                    (this.width / 2) * viewport.magnificationX,
                    (this.height / 2) * viewport.magnificationY,
                    0,
                    0,
                    2 * Math.PI,
                );
                ctx.fillStyle = "#ffee4b88";
                ctx.fill();
            }
        }
    }
}
